import { render, staticRenderFns } from "./NotifyUsersEditor.vue?vue&type=template&id=1c537b3e&"
import script from "./NotifyUsersEditor.vue?vue&type=script&lang=js&"
export * from "./NotifyUsersEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports